import styled from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";

export const StyledCenteredBaseCell = styled(BaseCell)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;
